import LazyLoad from "vanilla-lazyload";
import Glide from '@glidejs/glide';
import Spruce from '@ryangjchandler/spruce'; // Initialize Spruce before alpine
import alpine from 'alpinejs';


Spruce.store('menu', {
    open: false
})

// Spruce.watch('menu', function (value){
//     console.log(value);
// })


// Image Lazy Loading
var lazyLoadImages = new LazyLoad({
    elements_selector: ".lazy",
    use_native: true,
    unobserve_entered: true,
});



// Initialize sliders
let contentSliders1 = document.querySelectorAll('.block-images-text .image-slider');
if (contentSliders1.length) {
    // console.log('contentSliders1: ' + contentSliders1.length);
    contentSliders1.forEach(function (slider) {
        new Glide(slider, {
            gap: 16,
        }).mount();
    });
}

let contentSliders2 = document.querySelectorAll('.block-images .image-slider');
if (contentSliders2.length) {
    // console.log('contentSliders2: ' + contentSliders2.length);
    contentSliders2.forEach(function (slider) {
        new Glide(slider, {
            perView: 3,
            bound: true,
            gap: 24,
            breakpoints: {
                640: {
                    perView: 1,
                    gap: 16,
                }
            }
        }).mount();
    });
}

let headerSlider = document.querySelector('.header-slider');
if (headerSlider) {
    let interval = false;
    let intervalAttr = headerSlider.dataset.autoplay;
    if (intervalAttr) {
        interval = intervalAttr;
    }

    new Glide(headerSlider, {
        type: 'carousel',
        gap: 0,
        autoplay: interval,
        animationTimingFunc: 'ease',
        animationDuration: 800,
        hoverpause: false
    }).mount();
}



// Toggle header class
const stickyHeaderEl = document.querySelector('.site-header');
const headerTriggerEl = document.querySelector('.header-sentinel');

if (stickyHeaderEl && headerTriggerEl) {
    let toggleHeaderClass = function (entries) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
                stickyHeaderEl.classList.add('top');
            } else {
                stickyHeaderEl.classList.remove('top');
            }
        });
    }

    const headerObserver = new IntersectionObserver(toggleHeaderClass);

    headerObserver.observe(headerTriggerEl);
}